export default "__VITE_ASSET__766f500e__"